<script setup lang="ts">
import { ref, onUpdated } from 'vue'

const props = defineProps({
    theme: Object,
    forms: Object,
})
const form = defineModel('form');
const showChatWindow = defineModel('showChatWindow');
const messages = ref([{ role: 'assistant', content: 'Ahoj, tady Roori AI 💜. Jak ti můžu pomoct?' }])
const input = ref('')
const messagesEl = ref<HTMLElement | null>(null)

function handleToolCall(call: any) {
    console.log('Handle tool call with params:', call)
    switch (call.function.name) {
        case 'switch_back_to_basic_form':
            messages.value.push({ role: 'assistant', content: 'Jistě, přepnu vás do klasického prostředí.' });
            setTimeout(() =>
                showChatWindow.value = false, 1500);
            break;

        case 'prepare_reservation':
            form.value.name = call.function.arguments.name;
            form.value.email = call.function.arguments.email;
            form.value.phone = call.function.arguments.phone;
            form.value.day = call.function.arguments.date;
            form.value.timeslot = call.function.arguments.time_start + '/' + call.function.arguments.time_end;
            break;
    }

    // tady můžeš rovnou callnout Laravel funkci na vytvoření rezervace nebo jiné API
}

function sendMessage() {
    const msg = input.value
    messages.value.push({ role: 'user', content: msg })
    input.value = ''

    const eventSource = new EventSource(`/api/diva-ai?id_forms=${props.forms.id}&message=` + encodeURIComponent(msg))

    messages.value.push({ role: 'assistant', content: '' })

    let lastToolCallsChunk: string = ''

    eventSource.onmessage = (event) => {

        if (event.data === "[DONE]") {
            eventSource.close()
            try {
                if (lastToolCallsChunk.length > 0) {
                    const parsedCalls = JSON.parse(lastToolCallsChunk)
                    if (Array.isArray(parsedCalls)) {
                        parsedCalls.forEach(call => {
                            handleToolCall(call)
                        })
                    } else {
                        handleToolCall(parsedCalls)
                    }
                }
            } catch (e) {
                console.error('Failed to handle tool calls:', e)
            }
            return
        }
        try {
            const data = JSON.parse(event.data)
            if (data.tool_calls) {
                lastToolCallsChunk = JSON.stringify(data.tool_calls)
            }
            if (data.content) {
                messages.value[messages.value.length - 1].content += data.content
            }
        } catch (e) {
            // pokud se nepodaří parse, připoj data jako text
            if (event.data) {
                messages.value[messages.value.length - 1].content += event.data
            }
        }
    }
}

onUpdated(() => {
  if (messagesEl.value) {
    messagesEl.value.scrollTop = messagesEl.value.scrollHeight
  }
})
</script>

<template>
  <div
    :class="[
      'flex flex-col w-full mx-auto absolute bg-white/50 backdrop-blur z-50 h-full',
    ]"
  >
    <div
      ref="messagesEl"
      :class="[
        'flex-1 overflow-y-auto p-4 flex flex-col gap-2',
      ]"
    >
      <transition-group
        name="message"
        tag="div"
        class="flex flex-col gap-2 transition-transform ease-out duration-300"
        enter-from-class="translate-y-2 opacity-0"
        enter-active-class="transition-transform ease-out duration-300"
        leave-to-class="translate-y-2 opacity-0"
        leave-active-class="transition-transform ease-out duration-300"
      >
        <div
          v-for="(message, index) in messages.filter(el => el.content)"
          :key="index"
          :class="[
            'max-w-[70%] p-3 rounded-2xl break-words text-base leading-relaxed',
            message.role === 'user'
              ? [
                  'bg-gradient-to-tr text-white self-end rounded-br-sm shadow-md',
                  theme.color
                    ? `from-${theme.color}-500 to-${theme.color}-700`
                    : 'from-[#6a11cb] to-[#2575fc]'
                ]
              : 'bg-white text-gray-800 self-start border border-gray-200 rounded-bl-sm shadow-none',
            theme.darkMode && message.role === 'assistant' ? 'dark:bg-gray-700 dark:text-gray-100 dark:border-gray-600' : ''
          ]"
        >
          {{ message.content }}
        </div>
      </transition-group>
    </div>
    <form @submit.prevent="sendMessage" :class="[
      'flex p-3 bg-neutral-50 border-t',
      theme.darkMode ? 'dark:bg-gray-900 dark:border-gray-700' : ''
    ]">
      <input
        v-model="input"
        type="text"
        placeholder="Napište zprávu"
        autocomplete="off"
        :class="[
          'flex-1 px-4 py-2 border text-base outline-none transition-colors duration-300',
          theme.darkMode ? 'dark:bg-gray-800 dark:text-gray-100 dark:border-gray-600' : 'bg-white border-gray-300',
          `focus:border-${theme.color}-500 focus:shadow-${theme.color}-500`,
          `rounded-[${theme.roundness}px]`
        ]"
      />
      <button
        type="submit"
        :class="[
          'ml-3 px-6 py-2 text-base text-white cursor-pointer shadow-lg transition-colors duration-300',
          'bg-gradient-to-tr',
          theme.color
            ? `from-${theme.color}-500 to-${theme.color}-700`
            : 'from-[#6a11cb] to-[#2575fc]',
          'hover:bg-gradient-to-tr',
          theme.color
            ? `hover:from-${theme.color}-700 hover:to-${theme.color}-500`
            : 'hover:from-[#2575fc] hover:to-[#6a11cb]',
          `rounded-[${theme.roundness}px]`
        ]"
      >
        Odeslat
      </button>
    </form>
  </div>
</template>
